import { Currency, IStore } from "@lib";
import { IGoodMacroOpenContext, IMacro } from "../macro";
import { MacroAutocomplete } from "@core/controls/document-template-editor/document-template-macros-autocompleter";
import { WarrantyUtils } from "@/utils/types/warranty.utils";
import { ApiBaseUrl } from "@core/usecases/axios";
import { Localizer } from "@/i18n/localizer";
import * as filters from "@/filters";
import { companyMacroAutocomplete, CompanyMacroList } from "./company-macro-list";

export const goodMacroAutocomplete: MacroAutocomplete[] = [
    {
        type: "autocompleteitem",
        text: "Дата",
        value: "дата",
        nested: [{ type: "autocompleteitem", text: "Сегодня", value: "сегодня" }],
    },
    {
        type: "autocompleteitem",
        text: "Товар",
        value: "товар",
        nested: [
            { type: "autocompleteitem", text: "Артикул", value: "артикул" },
            { type: "autocompleteitem", text: "Наименование", value: "наименование" },
            { type: "autocompleteitem", text: "Описание", value: "описание" },
            { type: "autocompleteitem", text: "Себестоимость", value: "себестоимость" },
            { type: "autocompleteitem", text: "Цена", value: "цена" },
            { type: "autocompleteitem", text: "Количество", value: "количество" },
            { type: "autocompleteitem", text: "Гарантия", value: "гарантия" },
            { type: "autocompleteitem", text: "Штрихкод", value: "штрихкод" },
        ],
    },
    {
        type: "autocompleteitem",
        text: "Склад",
        value: "склад",
        nested: [
            { type: "autocompleteitem", text: "Номер", value: "номер" },
            { type: "autocompleteitem", text: "Название", value: "название" },
            { type: "autocompleteitem", text: "Описание", value: "описание" },
            { type: "autocompleteitem", text: "Валюта", value: "валюта" },
        ],
    },

    ...companyMacroAutocomplete,
];

export const GoodMacroList: IMacro<IGoodMacroOpenContext>[] = [
    // общее

    {
        alias: ["дата.сегодня", "date.now"],
        open: (context, args) => filters.datetime.datetime(new Date().toUTCString(), "L"),
    },
    ...CompanyMacroList,

    // товар

    {
        alias: ["товар.артикул", "good.sku"],
        open: (context, args) => context.good.info.sku,
    },
    {
        alias: ["товар.наименование", "good.name"],
        open: (context, args) => context.good.info.name,
    },
    {
        alias: ["товар.описание", "good.description"],
        open: (context, args) => context.good.info.description,
    },
    {
        alias: ["товар.себестоимость", "good.cost"],
        open: (context, args) => {
            const locale = context.good?.storeRef?.info?.locale;
            return filters.money.moneyFormat(context.good.info.cost, { locale });
        },
    },
    {
        alias: ["товар.цена", "good.price"],
        open: (context, args) => {
            const locale = context.good?.storeRef?.info?.locale;
            return filters.money.moneyFormat(context.good.info.price, { locale });
        },
    },
    {
        alias: ["товар.количество", "good.quantity"],
        open: (context, args) => context.good.info.quantity.toString(),
    },
    {
        alias: ["товар.гарантия", "good.warranty"],
        open: (context, args) => WarrantyUtils.toString(context.good.info.warranty),
    },
    {
        alias: ["товар.штрихкод", "good.barcode"],
        open: (context, args) => {
            if (!context.good.info.barcodes || context.good.info.barcodes.length === 0) {
                return "";
            }

            // %(товар.штрихкод:120,15)
            const width = args && args.length >= 1 ? args[0] : "120";
            const height = args && args.length >= 2 ? args[1] : "15";
            const barcode = context.good.info.barcodes[0];
            const url = `${ApiBaseUrl}barcodes/?code=${barcode.code}&type=${barcode.type}&height=${height}`;

            return `<img
                src="${url}"
                width="${width}"
                alt="Штрихкод ${barcode.code}"
                class="w-2 h-4 mr-0.5"
            />`;
        },
    },

    // склад

    {
        alias: ["склад.номер", "store.number"],
        open: (context, args) => context.store?.number?.toString(),
    },
    {
        alias: ["склад.название", "store.name"],
        open: (context, args) => context.store?.info.name,
    },
    {
        alias: ["склад.описание", "store.description"],
        open: (context, args) => context.store?.info.description,
    },
    {
        alias: ["склад.валюта", "store.currency"],
        open: (context, args) => Localizer.currencySymbol(context.store?.info.currency ?? Currency.RUB),
    },
];
